// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-labfront .chevron {
  transform-origin: 50% 50%;
}
.kb-labfront .chevron path {
  stroke: #000;
}
.kb-labfront .chevron.down {
  transform: rotate(90deg);
}
.kb-labfront .chevron.left {
  transform: rotate(180deg);
}
.kb-labfront .chevron.up {
  transform: rotate(270deg);
}`, "",{"version":3,"sources":["webpack://./src/components/pageElements/Chevron/Chevron.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;AAAE;EACE,YAAA;AAEJ;AAAE;EACE,wBAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ","sourcesContent":[".kb-labfront .chevron {\n  transform-origin: 50% 50%;\n  path {\n    stroke: #000;\n  }\n  &.down {\n    transform: rotate( 90deg );\n  }\n  &.left {\n    transform: rotate( 180deg );\n  }\n  &.up {\n    transform: rotate( 270deg );\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
